// Static copy for the Privacy Policy modal. Each section: title, optional lead
// paragraph, optional bullets, optional trailing paragraph.
export const PRIVACY_LAST_UPDATED = 'January 2025';

export const PRIVACY_INTRO = 'Jessica Burnette, operating as Jess Sells East Coast ("we," "us," or "our"), is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information when you visit our website or use our services.';

export const PRIVACY_SECTIONS = [
  {
    title: 'Information We Collect',
    lead: 'We may collect personal information that you voluntarily provide to us when you:',
    bullets: [
      'Fill out contact forms or request a home valuation',
      "Download our buyer's, seller's, or relocation guides",
      'Subscribe to our newsletter or marketing communications',
      'Contact us via phone, email, or text message',
    ],
    after: 'This information may include your name, email address, phone number, property address, and other details relevant to your real estate needs.',
  },
  {
    title: 'How We Use Your Information',
    lead: 'We use the information we collect to:',
    bullets: [
      'Respond to your inquiries and provide real estate services',
      'Send you property listings, market updates, and relevant information',
      'Communicate with you via phone, email, or text (if you have opted in)',
      'Improve our website and services',
    ],
  },
  {
    title: '🔒 Data Protection Commitment',
    highlight: true,
    lead: 'Your data will NOT be sold or shared with third parties for promotional or marketing purposes.',
    after: 'We do not sell, rent, or lease your personal information to third parties for their marketing purposes. We only share your information with service providers who assist us in operating our business (such as our brokerage, Swell Realty Co.) and only as necessary to provide our real estate services to you.',
  },
  {
    title: 'Text Message & Call Consent',
    lead: 'By providing your phone number and checking the consent box on our forms, you agree to receive calls, text messages, and emails from Jess Sells East Coast regarding real estate services. You may opt out at any time by:',
    bullets: ['Replying "STOP" to any text message', 'Clicking the unsubscribe link in any email', 'Contacting us directly at 252-564-5612'],
    after: 'Message and data rates may apply. Message frequency may vary based on your real estate needs and market activity.',
  },
  {
    title: 'Data Security',
    lead: 'We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.',
  },
  {
    title: 'Your Rights',
    lead: 'You have the right to:',
    bullets: [
      'Request access to the personal information we hold about you',
      'Request correction of any inaccurate information',
      'Request deletion of your personal information',
      'Opt out of marketing communications at any time',
    ],
  },
  {
    title: 'California Residents',
    lead: 'If you are a California resident, you have additional rights under the California Consumer Privacy Act (CCPA). We do not sell your personal information as defined by the CCPA.',
  },
];

export const PRIVACY_CONTACT_LINES = [
  'Jessica Burnette - Jess Sells East Coast',
  'Swell Realty Co.',
  '2122 General Booth Blvd Suite 104',
  'Virginia Beach, VA 23454',
  'Phone: 252-564-5612',
  'Email: jesssellseastcoast@gmail.com',
];
